export const getColumns = (
  intl,
  getLinkReceipt,
  getLinkInvoice,
  getLinkInvoiceXML
) => [
  {
    field: 'charge_name',
    headerName: intl.formatMessage({ id: 'app.invoices.grid.CharNameCol' }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: intl.formatMessage({ id: 'app.invoices.grid.pdfReceiptCol' }),
    flex: 1,
    align: 'left',
    field: 'url_pdf',
    headerAlign: 'left',
    renderCell: (rowData) => {
      return getLinkReceipt(rowData.row.url_receipt);
    },
  },
  {
    headerName: intl.formatMessage({ id: 'app.invoices.grid.pdfPreInvCol' }),
    flex: 1,
    align: 'left',
    field: 'url_receipt_preinvoiced',
    headerAlign: 'left',
    renderCell: (rowData) =>
      getLinkReceipt(rowData.row.url_receipt_preinvoiced),
  },
  {
    headerName: intl.formatMessage({ id: 'app.invoices.grid.pdfIvnvoiceCol' }),
    flex: 1,
    align: 'left',
    field: 'url_invoice',
    headerAlign: 'left',
    renderCell: (rowData) => getLinkInvoice(rowData.row.url_invoice),
  },
  {
    headerName: intl.formatMessage({ id: 'app.invoices.grid.xmlCol' }),
    sortable: false,
    flex: 1,
    align: 'left',
    field: 'url_invoice_xml',
    headerAlign: 'left',
    renderCell: (rowData) => getLinkInvoiceXML(rowData.row.url_invoice_xml),
  },
];
